import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'rsuite/dist/rsuite.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from "@uidotdev/usehooks";
import Dashboard from './Components/Backoffice/Dashboard/Dashboard';
import Page1 from './Components/Backoffice/Menu/Menu';
import CustomNavbar from './Components/Backoffice/Navbar/Navbar';
import LoginNavbar from './Components/Navbar/Navbar';
import Login from './Components/Login/Login';
import Footer from './Components/Footer/Footer';
import UserList from './Components/Backoffice/AffiliateManager/AffiliateList/AffliateList';
import Adduser from './Components/Backoffice/AffiliateManager/AddAffliate/AddAffliate';
import UserReview from './Components/Backoffice/AffiliateManager/AffiliateReview/AffliateReview';
import ForgetPassword from './Components/ForgetPassword/ForgetPassword';
import Blankpage from './Components/Backoffice/BlankPage/BlankPage';


function App() {
  const dispatch = useDispatch();
  const userx = useSelector(state => state.user);
  const [loaded, setLoaded] = useState(false);
  const [userLoaded, setUserLoaded] = useState(false);
  const CheckAuthorization = async () => {
    const userResponse = await axios.get(window.__CFG.API + "manager/GetUser", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })

    if (userResponse.data.Error == null) {
      dispatch({
        type: "SET_USER",
        data: {
          logged: true,
          user: userResponse.data.User,
        }
      })
      setUserLoaded(true);
    } else {
      setUserLoaded(true);
    }
  }

  useEffect(() => {
    if (localStorage.getItem("raff-token") != undefined) {
      CheckAuthorization();
    } else {
      setUserLoaded(true);
    }
  }, []);
  
  // useEffect(() => { console.log(userLoaded) }, [userLoaded])
  // useEffect(() => {if(!userx.Logged)navigate("/") })
  return (
    <>
      <div className="App">
        <Toaster />

        <Router>
          <Routes>
            <Route path="/" element={
              <>
                {
                  userx.Logged ? (
                    !userLoaded ? (<Blankpage />) : (
                      <Navigate to="/dashboard"></Navigate>
                    )
                  ) : (
                    <>
                      {!userLoaded ? (<Blankpage />) :
                        (
                          <Login />
                        )}
                    </>
                  )
                }
              </>
            }>
            </Route>
            {userx.Logged ? (
              <>
                <Route path="/dashboard" element={<Dashboard />}>
                </Route>
                <Route path="/affiliate/*" element={<Page1 />}>
                </Route>

              </>
            ) : (<></>)}
            <Route path='/forgetpassword' element={<ForgetPassword />}></Route>
          </Routes>
        </Router>
        {/* <Footer /> */}
      </div>
      {/* <div>
        <Footer/>
      </div> */}
    </>
  );
}

export default App;
